

import { Box, Typography } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react';
import { getToken } from '../../utils/utils';
import { viewretailers } from './api';


interface Retailer {
  id: number;
  account_id: string;
  contact_id: string | null;
  trade_channel: string | null;
  name: string | null;
  billingcity: string | null;
  location_type: String | null;
  billing_state: string | null;

  billing_country: string | null;

  active: string;
}

function Retailers() {
  const [retailers, setRetailers] = useState<Retailer[]>([]);
  const token = getToken();

  useEffect(() => {
    viewretailers(token)
      .then((res) => {
        console.log('Full Response:', res);
        console.log('Data:', res.data);


        const responseData = res.data?.data || res.data;
        console.log('Response Data:', responseData);

        if (Array.isArray(responseData) && responseData.length > 0) {
          const mappedData: Retailer[] = responseData.map((retailer: any) => ({
            id: retailer.id,
            account_id: retailer['account.account_id'],
            contact_id: retailer['retailer.contact_id'],
            trade_channel: retailer['account.trade_channel'],
            name: `${retailer['retailer.first_name']} ${retailer['retailer.last_name']}`,
            billingcity: retailer['account.billing_city'],
            location_type: retailer['account.location_type'],
            billing_state: retailer['account.billing_state'],
            billing_country: retailer['account.billing_country'],
            active: retailer.active,
          }));
          console.log('Mapped Data:', mappedData);
          setRetailers(mappedData);
        } else {
          console.log('No retailers found');
        }
      })
      .catch((err) => {
        console.log('Error:', err);
      });
  }, [token]);

  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 70 },
    { field: 'account_id', headerName: 'Account ID', width: 150 },
    { field: 'contact_id', headerName: 'Contact ID', width: 150 },
    { field: 'trade_channel', headerName: 'Trade Channel', width: 150 },
    { field: 'name', headerName: 'Name', width: 200 },
    { field: 'billingcity', headerName: 'Billing City', width: 200 },
    { field: 'location_type', headerName: 'location_type', width: 150 },
    { field: 'billing_state', headerName: 'Billing_state', width: 150 },
    { field: 'billing_country', headerName: 'Country', width: 150 },
    // { field: 'active', headerName: 'Active', width: 100 },
  ];

  return (
    <Box p={3}>
      <Typography sx={{ marginBottom: '34px' }} variant="h4">
        Retailers
      </Typography>
      {retailers.length === 0 ? (
        <Typography variant="h6">No retailers available.</Typography>
      ) : (
        <div style={{ height: 400, width: '100%' }}>
          <DataGrid
            rows={retailers}
            columns={columns}
            sx={{
              "& .MuiDataGrid-row--borderBottom": {
                background: "#eef4ff !important",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                fontWeight: "400",
                color: "#333",
                cursor: 'pointer'

              },
              "& .MuiDataGrid-sortIcon": {
                opacity: "1 !important",
                visibility: 'visible', // 👈 Add this
              },

            }
            }
            initialState={{
              pagination: {
                paginationModel: { pageSize: 10 },
              },
            }}
            checkboxSelection
          />
        </div>
      )}
    </Box>
  );
}

export default Retailers;
